import React, { useState, useEffect } from 'react'
import moment from 'moment'

import RepeatOccurrenceArrow from '../RepeatOccurrenceArrow'
import RepeatEndRadio from './RepeatEndRadio'
import RepeatEndOccurrence from './RepeatEndOccurrence.js'
import RepeatEndDatePicker from './RepeatEndDatePicker'

import { REPEAT_BOOKING } from '../../../../helpers'

import { StylesRepeatEnd } from './styles'

const RepeatEnd = (props) => {
  const {
    date,
    language,
    isSelectedRepeatEndsOn,
    repeatEndsOn,
    repeatEndsAfterOccurrence: occurrence,
    onUpdateIsSelectedRepeatEndsOn,
    onEndsOn,
    onEndsAfterOccurrence,
    getHolidays,
    holidays,
    colorTheme
  } = props

  const [isOpenDatePicker, setIsOpenDatePicker] = useState(false)
  const [selectedDate, setSelectedDate] = useState(repeatEndsOn)
  const [isSelectedEndsOn, setIsSelectedEndsOn] = useState(isSelectedRepeatEndsOn)
  const [isSelectedEndsAfter, setIsSelectedEndsAfter] = useState(!isSelectedRepeatEndsOn)
  const [errorMessage, setErrorMessage] = useState('')
  const [errorClassName, setErrorClassName] = useState('')

  const handleEndsOn = (_isSelectedEndsAfter) => {
    if (_isSelectedEndsAfter) {
      setIsSelectedEndsAfter(false)
    }

    setIsSelectedEndsOn(true)
    onUpdateIsSelectedRepeatEndsOn(true)
  }

  const handleEndsAfter = (_isSelectedEndsOn, defaultDate) => {
    if (_isSelectedEndsOn) {
      setIsSelectedEndsOn(false)
      onUpdateIsSelectedRepeatEndsOn(false)
    }

    setSelectedDate(moment(defaultDate))
    setIsSelectedEndsAfter(true)
  }

  const handleSetOccurrence = (_occurrence) => {
    onEndsAfterOccurrence(_occurrence)
  }

  const clearError = () => {
    setErrorMessage('')
    setErrorClassName('')
  }

  const handleInputChange = (text, language) => {
    if (/^[0-9]*$/.test(text)) {
      handleSetOccurrence(text)
    }

    if (Number(text) > 0) {
      clearError()
    } else {
      setErrorMessage(REPEAT_BOOKING.OCCURRENCES_ERROR[language])
      setErrorClassName('box-error')
    }
  }

  const onPressDatePicker = (_isSelectedEndsOn) => {
    setIsOpenDatePicker(_isSelectedEndsOn)
  }

  const onCloseDatePicker = () => {
    setIsOpenDatePicker(false)
  }

  const handleSelectedDate = (selectedDate) => {  
    const newSelectedDate = moment(selectedDate)
    
    setSelectedDate(newSelectedDate)
    onEndsOn(newSelectedDate)
    onCloseDatePicker()
  }

  const getStyleActiveContent = (isActive) => {
    return isActive ? 'active-content' : 'inactive-content'
  }

  useEffect(() => {
    if (Number(occurrence) > 0) {
      clearError()
    }
  }, [occurrence])

  return (
    <StylesRepeatEnd colorTheme={colorTheme}>
      <label className='title'>{REPEAT_BOOKING.ENDS[language]}</label>

      <div className='ends-on-section'>
        <RepeatEndRadio
          isSelected={isSelectedEndsOn}
          value={REPEAT_BOOKING.ON_DATE[language]}
          onSelected={() => handleEndsOn(isSelectedEndsAfter)}
        />

        <RepeatEndDatePicker
          className={getStyleActiveContent(isSelectedEndsOn)}
          isSelected={isSelectedEndsOn}
          isOpenDatePicker={isOpenDatePicker}
          selectedDate={selectedDate}
          onPressDatePicker={onPressDatePicker}
          onCloseDatePicker={onCloseDatePicker}
          handleSelectedDate={handleSelectedDate}
          language={language}
          getHolidays={getHolidays}
          holidays={holidays}
          colorTheme={colorTheme}
        />
      </div>

      <div className='ends-after-section'>
        <RepeatEndRadio
          isSelected={isSelectedEndsAfter}
          value={REPEAT_BOOKING.AFTER[language]}
          onSelected={() => handleEndsAfter(isSelectedEndsOn, date)}
        />

        <RepeatEndOccurrence
          className={`${getStyleActiveContent(isSelectedEndsAfter)} ${errorClassName}`}
          isSelected={isSelectedEndsAfter}
          occurrence={occurrence}
          language={language}
          onChange={handleInputChange}
        />

        <RepeatOccurrenceArrow
          className={getStyleActiveContent(isSelectedEndsAfter)}
          occurrence={occurrence}
          setOccurrence={handleSetOccurrence}
          isDisabled={!isSelectedEndsAfter}
        />
      </div>

      {errorMessage && <label className='error-message'>{errorMessage}</label>}
    </StylesRepeatEnd>
  )
}

export default RepeatEnd
